import { MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import type { Athlete } from '../../types/domain'

const cityCoordinates: Record<string, { x: number; y: number }> = {
  Annecy: { x: 73, y: 55 },
  Chambéry: { x: 70, y: 61 },
  Lyon: { x: 62, y: 56 },
  Grenoble: { x: 68, y: 64 },
  Nantes: { x: 27, y: 46 },
  Marseille: { x: 66, y: 82 },
  Lille: { x: 55, y: 13 },
  Toulouse: { x: 43, y: 76 },
  Bordeaux: { x: 31, y: 68 },
  Paris: { x: 52, y: 32 },
}

export function FranceTalentMap({ athletes }: { athletes: Athlete[] }) {
  return <section className="talent-map" aria-label="Carte des athlètes en France">
    <div className="talent-map__header"><MapPin size={18} /><div><strong>Athlètes en France</strong><span>{athletes.length} profils visibles</span></div></div>
    <div className="talent-map__canvas">
      <svg className="france-shape" viewBox="0 0 800 780" role="img" aria-label="Silhouette simplifiée de la France métropolitaine">
        <defs>
          <linearGradient id="franceFill" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#EAF2FF" /><stop offset="1" stopColor="#E8FBF7" /></linearGradient>
          <filter id="softShadow" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="14" stdDeviation="18" floodColor="#071A3A" floodOpacity="0.10" /></filter>
        </defs>
        <path filter="url(#softShadow)" fill="url(#franceFill)" stroke="#B9C9DE" strokeWidth="7" strokeLinejoin="round" d="M347 59 L456 72 L528 117 L618 145 L682 222 L661 302 L704 376 L671 467 L621 516 L603 592 L535 625 L489 710 L412 733 L347 692 L280 715 L223 668 L171 637 L144 571 L94 524 L110 448 L73 381 L103 313 L96 239 L153 197 L193 125 L268 112 Z" />
        <path fill="#EAF2FF" stroke="#B9C9DE" strokeWidth="5" d="M714 645 C743 631 764 650 756 682 C748 714 722 735 701 715 C683 697 689 658 714 645Z" />
      </svg>
      {athletes.map((athlete) => {
        const point = cityCoordinates[athlete.city] ?? { x: 50, y: 50 }
        return <Link className="talent-pin" style={{ left: `${point.x}%`, top: `${point.y}%` }} to={`/athletes/${athlete.slug}`} key={athlete.id} title={`${athlete.firstName} ${athlete.lastName} — ${athlete.city}`}>
          <img src={athlete.photo} alt="" /><span><strong>{athlete.firstName}</strong><small>{athlete.city}</small></span>
        </Link>
      })}
    </div>
  </section>
}
